export enum OktaLocalStorageKeys {
  OktaOriginalUriStorage = 'okta-original-uri-storage',
  OktaCacheStorage = 'okta-cache-storage',
  OktaSharedTransactionStorage = 'okta-shared-transaction-storage',
  OktaTokenStorage = 'okta-token-storage',
}
